<script>
export default {
  data: function() {},
  methods: {
    get_Login_User: function() {
      this.$store.dispatch("auth/set_User").then(
        () => {
          this.get_List();
        },
        () => {
          this.$router.push({
            name: "Login"
          });
        }
      );
    }
  },
  created: function() {
    this.get_Login_User();
  },
  computed: {
    user() {
      return this.$store.getters["auth/get"];
    }
  }
};
</script>
